import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useChannels } from '../context/CategoriesContext';

export default function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const channels = useChannels().map((c, i) => ({ ...c, label: String(i).padStart(2, '0') }));

  // Auto-close the mobile menu whenever the route changes.
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="relative z-40 border-b border-[#3a2512] bg-[#120804]">
      <div className="w-full px-4 md:px-6 py-3 md:py-6 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center group shrink-0" data-testid="header-logo-link">
          <div className="font-display text-xl md:text-2xl text-[#ffe9b8] leading-none chroma tv-blink whitespace-nowrap">
            OWEN DILLEY
          </div>
        </Link>

        {/* Desktop nav — hidden below md */}
        <nav className="hidden md:flex flex-wrap gap-2 justify-end" data-testid="header-nav">
          {channels.map((c) => {
            const active = location.pathname === c.path;
            return (
              <Link
                key={c.path}
                to={c.path}
                data-testid={`header-tab-${c.key}`}
                className={`header-tab px-3 py-2 font-osd text-xs lg:text-sm tracking-wider border-2 rounded-sm whitespace-nowrap ${active ? 'header-tab-active' : ''}`}
              >
                <span className="opacity-70 mr-1.5">{c.label}</span>
                <span className="font-semibold">{c.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* Mobile hamburger — visible below md */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          data-testid="header-menu-toggle"
          className="header-tab md:hidden w-10 h-10 flex items-center justify-center border-2 rounded-sm"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile dropdown panel */}
      {open && (
        <nav
          data-testid="header-mobile-nav"
          className="md:hidden border-t border-[#3a2512] bg-[#0a0502] px-3 py-3 flex flex-col gap-1.5"
        >
          {channels.map((c) => {
            const active = location.pathname === c.path;
            return (
              <Link
                key={c.path}
                to={c.path}
                data-testid={`header-mobile-tab-${c.key}`}
                className={`header-tab px-3 py-2.5 font-osd text-sm tracking-wider border-2 rounded-sm flex items-center gap-3 ${active ? 'header-tab-active' : ''}`}
              >
                <span className="opacity-70 text-xs w-6 shrink-0">{c.label}</span>
                <span className="font-semibold">{c.name}</span>
              </Link>
            );
          })}
        </nav>
      )}
    </header>
  );
}
